"use strict";

var _regeneratorRuntime = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignOut = void 0;

var react_1 = __importDefault(require("react"));

var aws_amplify_1 = require("aws-amplify");

var theme_ui_1 = require("theme-ui");

var ui_components_1 = require("@aws-amplify/ui-components");

function signOut() {
  return _signOut.apply(this, arguments);
}

function _signOut() {
  _signOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return aws_amplify_1.Auth.signOut();

          case 3:
            // copied from https://github.com/aws-amplify/amplify-js/blob/df95ea3724eb6406f64b03f25086cd3e8644cb5f/packages/amplify-ui-components/src/common/helpers.ts#L34
            // to make the component re-render properly
            aws_amplify_1.Hub.dispatch('UI Auth', {
              event: 'AuthStateChange',
              message: ui_components_1.AuthState.SignedOut
            });
            _context2.next = 9;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            console.log('error signing out: ', _context2.t0);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _signOut.apply(this, arguments);
}

var SignOut = function SignOut(_ref) {
  var onSignOut = _ref.onSignOut;
  return react_1.default.createElement(theme_ui_1.Button, {
    onClick: function () {
      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return signOut();

              case 2:
                onSignOut === null || onSignOut === void 0 ? void 0 : onSignOut();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onClick() {
        return _onClick.apply(this, arguments);
      }

      return onClick;
    }(),
    sx: {
      backgroundColor: "#f90",
      paddingLeft: "2em",
      paddingRight: "2em"
    }
  }, "Sign Out");
};

exports.SignOut = SignOut;